function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 21,
  r: 3,
  fill: "#333"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 12,
  r: 3,
  fill: "#333"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  fill: "#333"
});

function SvgMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMenuIcon;